import { useState } from 'react';
import { SCENARIOS } from '../data/scenarios';
import { useScenario } from '../store/scenarioStore';

/**
 * Panel rétractable de scénarios pédagogiques.
 * En haut à droite du canvas, sous le panel Couches.
 */
export default function ScenariosPanel() {
  const [open, setOpen] = useState(false);  // collapsed by default
  const apply = useScenario((s) => s.applyScenario);

  return (
    <div className={`scenarios-panel ${open ? 'is-open' : ''}`}>
      <button className="scenarios-toggle" onClick={() => setOpen((v) => !v)}>
        <span>🎬 Tour guidé</span>
        <span className="scenarios-chevron">{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <div className="scenarios-list">
          <p className="scenarios-help">
            Sélectionne un événement astronomique pour voir le système solaire à ce moment précis.
          </p>
          {SCENARIOS.map((s) => (
            <button
              key={s.id}
              className="scenario-button"
              onClick={() => apply(s)}
              title={s.description}
            >
              <span className="scenario-emoji">{s.emoji}</span>
              <span className="scenario-info">
                <strong>{s.label}</strong>
                <em>{s.description}</em>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
